module.exports = __webpack_public_path__ + "img/LACOMER.eed83d52.png";